module.exports = __webpack_public_path__ + "static/media/progress_payment.d60371f9.svg";